import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { IconCore } from '../Icon.Core/Icon.Core.es.js';

// Circle Offset from the center in percentage (50%)
// And it's matching the circle in LottieIcons
const circleOffset = 50;
// Mapping of preset size to px values
const sizes = {
    /**
     * Large Size.
     */ large: 58,
    /**
     * Default Size.
     */ default: 48,
    /**
     * Small Size.
     */ small: 32,
    /**
     * Icon Size.
     */ icon: 24
};
const IconCircle = ({ className, size = 'default', intent = 'default', name, ...iconProps })=>{
    const iconName = name.toLowerCase();
    const classes = classNames('cb-icon-circle', intent, className);
    // Offset circle padding from the icon size
    const iconSize = sizes[size] - sizes[size] * (circleOffset / 100);
    return jsx("div", {
        className: classes,
        "data-testid": `icon-circle-${iconName}`,
        style: {
            width: sizes[size],
            height: sizes[size]
        },
        children: jsx(IconCore, {
            name: name,
            size: iconSize,
            ...iconProps
        })
    });
};
IconCircle.displayName = 'Icon.Circle';

export { IconCircle, IconCircle as default };
//# sourceMappingURL=Icon.Circle.es.js.map
